import { Dispatch } from "redux";
import { QuicktipActionTypes, QuicktipAction } from "../../types/Quicktip/quicktipTypes";
import axios from "axios";

interface ErrorResponse {
    code: number;
    message: string;
}

export const getQuicktipData = (id: string): any => {
    return async (dispatch: Dispatch<QuicktipAction>) => {
        try {
            dispatch({ type: QuicktipActionTypes.FETCH_QUICKTIP_DATA });
            const response = await axios({
                method: 'get',
                url: `/api/quicktip_cards/${id}`,
                withCredentials: false
            });
            dispatch({ type: QuicktipActionTypes.FETCH_QUICKTIP_DATA_SUCCESS, payload: response.data });
        } catch (error: any) {
            let errorPayload: ErrorResponse;
            if (error.response && error.response.data) {
                const { code, message } = error.response.data;
                errorPayload = { code, message };
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }
            dispatch({ type: QuicktipActionTypes.FETCH_QUICKTIP_DATA_ERROR, payload: errorPayload });
        }
    }
}
